import { Rich } from "@1-now/booking-core";
import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

/**
 * The home page's welcome pop-up (Design A and B).
 *
 * Its full-screen layer takes every tap on the page, so the layer must only ever exist while the
 * panel can be seen and closed (1NOW-11213: on an iPhone the Privacy Policy, Terms & Conditions
 * and Track my booking links at the foot of the home page did nothing). Hence:
 *
 * - No enter/leave transition. A transition parks the panel at `opacity-0` until an animation
 *   frame arrives and keeps the layer mounted until its leave ends; a phone web view that is not
 *   painting (an in-app browser still presenting) never delivers either, and an invisible layer
 *   was left over the page. The panel now fades in with a CSS keyframe (`.gpop-in`, index.css),
 *   which is the panel's resting look if it never runs, and it is unmounted the moment it closes.
 * - A tap outside the panel and Escape close it, as the Design C pop-up does: a visitor who
 *   taps the page behind it is shown it go, not a page that ignores them.
 */
const GlobalPopUp = ({
  onClose,
  isShowModal,
  popUpData,
}: {
  onClose: () => void;
  isShowModal: boolean;
  popUpData: any;
}) => {
  return (
    <Dialog as="div" className="relative z-50" open={isShowModal} onClose={onClose}>
      <div aria-hidden="true" className="gpop-fade fixed inset-0 bg-black bg-opacity-30" />

      <div className="fixed inset-0 flex items-center justify-center px-4 py-8">
        <Dialog.Panel className="gpop-in bg-bg-color text-text-color w-full max-w-md rounded-lg shadow-lg p-0">
          {/* Header */}
          <div className="flex items-center justify-between border-b px-6 py-4">
            <Dialog.Title className="text-xl font-semibold">
              {/* Rich: sanitised, and the operator's headings flattened �
                  this sits inside the dialog's title (1NOW-10615). */}
              <Rich as="span" html={popUpData?.heading} />
            </Dialog.Title>
            <button
              onClick={onClose}
              className="p-2 hover:bg-bg-color border rounded-full border-text-color transition"
            >
              <XMarkIcon className="h-5 w-5 text-text-color" />
            </button>
          </div>
          {/* Body */}
          <div className="px-6 py-5">
            <Rich as="span" html={popUpData?.description} />
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default GlobalPopUp;
